import ZeissButton from '@components/button';
import { Modal, Space } from 'antd';
import './deletePrompt.scss';

interface Props {
  cancelText?: string;
  confirmText?: string;
  popupTitle: string;
  confirmCallback: () => void;
  open: boolean;
  children?: any;
  setOpen: (value: boolean) => void;
}
export const DeletePrompt = ({
  cancelText = '取消',
  confirmText = '确认',
  popupTitle = '确认删除？',
  confirmCallback = () => {},
  open = false,
  children = <></>,
  setOpen
}: Props) => {
  const handleConfirm = () => {
    confirmCallback && confirmCallback();
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Modal
      width={520}
      open={open}
      onCancel={handleCancel}
      footer={null}
      centered
    >
      <div className="pc-deletePrompt-layout">
        <div className="pc-deletePrompt-title">{popupTitle}</div>
        <div>{children}</div>
        <Space className="pc-deletePrompt-footer" size="middle">
          <ZeissButton className="pc-normal-btn" onClick={handleCancel}>
            {cancelText}
          </ZeissButton>
          <ZeissButton className="pc-danger-btn" onClick={handleConfirm}>
            {confirmText}
          </ZeissButton>
        </Space>
      </div>
    </Modal>
  );
};
